import { Component, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { Size } from './services/size';
import { Meta } from '@angular/platform-browser';
import packageJson from 'package.json';
import { SocketService } from './services/socket/socket.service';
import { EventService } from './services/event/event.service';
import { PwaInstallService } from './services/pwa/pwa-install.service';
import { PwaUpdateService } from './services/pwa/pwa-update.service';
const { version } = packageJson;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
    public title = 'personal-account-frontend';
    public constructor(
        private size: Size,
        private meta: Meta,
        private socketService: SocketService,
        private eventService: EventService,
        private readonly pwaInstallService: PwaInstallService,
        private readonly pwaUpdateService: PwaUpdateService,
    ) {
        this.pwaInstallService.initialize();

        // Установка типа девайса
        this.size.setW(window.innerWidth);
        const token = document.cookie
            .split(';')
            .find((c) => c.trim().startsWith('pa-web_Patient_Local='));
        if (token && token.split('=')[1]) {
            this.eventService.emit('auth:login');
            const talonBlock = JSON.parse(
                localStorage.getItem('talonBlock') || '[]',
            );
            if (talonBlock.length > 0)
                talonBlock.forEach(
                    (item: { rnumbID: number; f_appoitment: boolean }) => {
                        if (item.rnumbID && !item.f_appoitment) {
                            setTimeout(() => {
                                this.socketService.unlockTalon(item.rnumbID);
                            }, 200);
                        }
                    },
                );
            localStorage.removeItem('talonBlock');
        }
    }

    public ngAfterViewInit(): void {
        this.updateVhUnits();
    }

    public ngOnInit(): void {
        this.meta.updateTag({
            name: 'product_version',
            value: version,
        });
        this.pwaUpdateService.initialize();
    }

    @HostListener('window:resize', ['$event'])
    public onResize(event: any) {
        this.updateVhUnits();
    }

    public updateVhUnits() {
        const vh = window.innerHeight * 0.01;
        document.body.style.setProperty('--vh', `${vh}px`);
    }
}
